import { render, staticRenderFns } from "./DeleteButtonWithConfirm.vue?vue&type=template&id=4a5a265b"
import script from "./DeleteButtonWithConfirm.vue?vue&type=script&lang=ts"
export * from "./DeleteButtonWithConfirm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports